import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { ViajesService } from 'src/app/services/viajes.service';
import { utils } from 'src/app/utils/utils';

@Component({
  selector: 'app-agregar-evidencia',
  templateUrl: './agregar-evidencia.component.html',
  styleUrls: ['./agregar-evidencia.component.scss']
})
export class AgregarEvidenciaComponent implements OnInit {
  private utils = new utils();
  settings: Settings;

  pedidos: any[] = [];
  pedidoEvidencias: any[] = [];
  imgUrl: any;

  evidencia: any = {};

  evidenciasForm: FormGroup;
  constructor(private _vs: ViajesService, public dialogRef: MatDialogRef<AgregarEvidenciaComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private formBuilder: FormBuilder, private _snackBar: MatSnackBar, public appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.buildForm();
    this.consultarPedidos();
  }

  buildForm() {
    this.evidenciasForm = this.formBuilder.group({
      descripcion: this.formBuilder.control({value: null, disabled: true}, [Validators.required]),
      pedido: this.formBuilder.control(null, [Validators.required]),
      pedidoEvidencias: this.formBuilder.control(null, [Validators.required]),
    });

    this.evidenciasForm.get('pedido').valueChanges.subscribe(
      p => {
        this.consultarPedidoEvidencias();
      }
    )

    this.evidenciasForm.get('pedidoEvidencias').valueChanges.subscribe(
      p => {
        this.evidenciasForm.get('descripcion').setValue(this.pedidoEvidencias.find(x => x.idEvidencia == p).descripcion)
      }
    )
  }

  consultarPedidos() {
    this._vs.consultarPedidosParadaDescarga(this.data.idRuta).subscribe(
      result => {
        if(result != null){
          this.pedidos = result;
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  consultarPedidoEvidencias() {
    this._vs.consultarPedidoEvidencias(this.evidenciasForm.get('pedido').value).subscribe(
      result => {
        if(result != null){
          this.pedidoEvidencias = result;
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  cargarImagen(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.imgUrl = event.target.result;
      }
    }
  }

  guardar() {
    this.settings.loadingSpinner = true;
    if(this.evidenciasForm.valid){
      if(this.imgUrl){
        this.bindModel();

        this.agregarEvidencia();
        console.log(this.evidencia);
      }else {
        this.settings.loadingSpinner = false;
        this._snackBar.open('Seleccione una imagen antes de continuar.', null, this.utils.config);
      }
    }else {
      this.settings.loadingSpinner = false;

      Object.keys(this.evidenciasForm.controls).forEach(key => {
        const ctrl = this.evidenciasForm.get(key);
        ctrl.markAsTouched({ onlySelf: true });
      });
    }
  }

  agregarEvidencia() {
    this._vs.agregarFotografiaEvidencia(this.evidencia).subscribe(
      result => {
        this.settings.loadingSpinner = false;
        this.cerrarModal();
      },
      error => {
        this.settings.loadingSpinner = false;
        console.log(error);
      }
    );
  }

  bindModel() {
    let idPedido = this.evidenciasForm.get('pedido').value;
    let idParada = this.pedidos.find(p => p.idPedido == idPedido).idParadaReal;
    let latitud = this.pedidos.find(p => p.idPedido == idPedido).latitud;
    let longitud = this.pedidos.find(p => p.idPedido == idPedido).longitud;

    this.evidencia = {
      descripcion: this.evidenciasForm.get('descripcion').value,
      idEvidencia: this.evidenciasForm.get('pedidoEvidencias').value,
      idPedido: idPedido,
      idParada: idParada,
      idRuta: this.data.idRuta,
      idRazonSocial: this.data.idRazonSocial,
      tipoFoto: 1,
      fecha: this.formatearFecha(new Date()),
      base64: this.imgUrl,
      latitud: latitud,
      longitud: longitud,
      extencionFoto: 'jpeg'
    }
  }

  cerrarModal() {
    this.dialogRef.close();
  }

  formatearFecha(fecha: Date): string {
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
    const dia = String(fecha.getDate()).padStart(2, '0');
    const hora = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');
    const segundos = String(fecha.getSeconds()).padStart(2, '0');
  
    return `${anio}-${mes}-${dia} ${hora}:${minutos}:${segundos}`;
  }
}
